module.exports = __webpack_public_path__ + "img/page3_table_bag.e20bf96e.png";